var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dat-wrapper"},[_c('depositRenderData',{attrs:{"data":_vm.savingAccountData,"view-button-text":_vm.viewButtonText,"bank-health":_vm.bankHealth,"has-error":_vm.hasError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }